import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listUnitsAction, editUnitsAction, deleteUnitsAction } from '../../../actions/unitsActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { UNIDADES_ELIMINAR, UNIDADES_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
//Función principal
const UnitList = props => {
    const params = {
        sort: 'descripcion:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const unitsLoading = useSelector( state => state.units.loading );
    const units = useSelector( state => state.units.units );
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ data, setData ] = useState(null);
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editUnitsAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteUnitsAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {
            name: 'Email',
            width: null,
            style: null,
            field: 'email',
        },
        {
            name: 'Perfil',
            width: null,
            style: null,
            field: 'perfil',
            subfield: 'descripcion'
        },
        {
            name: 'Fuero',
            width: null,
            style: null,
            field: 'fuero',
            subfield: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, UNIDADES_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, UNIDADES_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(units){
            //Seteo los datos
            setData(units);
        }else{
            //Si no hay datos, debo cargarlo
            dispatch( listUnitsAction(params) );
        }
    }, [units]);
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={units}
                            headers={headers}
                            setData={setData}
                        />
                        {
                            unitsLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            data ? (
                                <TableList
                                    prefix="unit"
                                    headers={headers}
                                    items={data}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnitList;